import React from 'react';
import { joinClassNames } from '../../../util/util';

interface SVGWrapperProps {
	id?: string;
	noMouseEvent?: boolean;
	isMobile?: boolean;
	className?: string;
	showVerticalViewBox?: boolean;
	style?: any;
	children?: React.ReactNode;
	onMouseLeave?: (_event: React.MouseEvent) => void;
	onMouseMove?: (_event: React.MouseEvent) => void;
	onTouchStart?: (_event: React.TouchEvent) => void;
	onTouchEnd?: (_event: React.TouchEvent) => void;
	onTouchMove?: (_event: React.TouchEvent) => void;
}

const baseClassName = 'interactOverlayContainer';

const SVGWrapper = ({
	noMouseEvent = true,
	className,
	id,
	showVerticalViewBox,
	style,
	children,
	isMobile,
	onMouseLeave,
	onMouseMove,
	onTouchStart,
	onTouchEnd,
	onTouchMove,
}: SVGWrapperProps) => {
	return (
		<svg
			className={joinClassNames(['mainSVG', baseClassName, noMouseEvent ? `${baseClassName}--noMouseEvent` : '', className])}
			id={id}
			width="100%"
			height="100%"
			viewBox={showVerticalViewBox ? '547 0 506 900' : '0 0 1600 900'}
			style={style}
			onMouseLeave={isMobile ? undefined : onMouseLeave}
			onMouseMove={isMobile ? undefined : onMouseMove}
			onTouchStart={onTouchStart}
			onTouchMove={onTouchMove}
			onTouchEnd={onTouchEnd}
		>
			{children}
			<use xlinkHref="https://play2.qbrick.com/custom/modules/interactiveoverlay/defaultScriptV3.js" />
		</svg>
	);
};

export default SVGWrapper;
